// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"763f8467","508":"3964e655","612":"8e9a976e","731":"4ed4084a","840":"7cf6be5a","926":"dc98f009"}[chunkId] + ".chunk.js";
};